import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconBookOpenFill';
/** Renders an SVG icon. */
const SvgBookOpenFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M25.64 5a10 10 0 0 0-7.218.671l-.87.434A1 1 0 0 0 17 7v19a1 1 0 0 0 1.447.894l1.206-.603a9 9 0 0 1 5.298-.86l2.766.396A2 2 0 0 0 30 23.847V7.754a2 2 0 0 0-1.45-1.923zM22 12a1 1 0 1 0 0 2h1a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zM13.579 5.671A10 10 0 0 0 6.359 5l-2.908.831A2 2 0 0 0 2 7.754v16.093a2 2 0 0 0 2.283 1.98l2.766-.396a9 9 0 0 1 5.298.86l1.206.603A1 1 0 0 0 15 26V7a1 1 0 0 0-.553-.895zM7 12a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2z"
      />
    </svg>
  );
};
SvgBookOpenFill.displayName = displayName;
export default SvgBookOpenFill;
